import React from "react"

import { graphql, withPrefix } from "gatsby"
import json from "../../content/data.json"

import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/style.scss"

import Hero from "../components/hero.component"
import Live from "../components/live.component"
import Started from "../components/started.component"
import ChooseExperience from "../components/choose.component"
import Category from "../components/experience/category.component"

import Helmet from "react-helmet"

class Index extends React.Component {
  render() {
    const { data, location } = this.props
    const siteTitle = data.site.siteMetadata?.title || ``

    let animationTime = 500;

    return (
      <Layout location={location} title={siteTitle}>
        <Helmet>
          <link
            href="https://unpkg.com/aos@2.3.1/dist/aos.css"
            rel="stylesheet"
            type="text/css"
          />
          <script
            onload="runAOS()"
            src={withPrefix("script.js")}
            type="text/javascript"
          />
        </Helmet>

        <SEO title={siteTitle} />
        <div>
          <Hero />
          <Live />
          <Started />
          <ChooseExperience />

          <div className="categories">
            {json.map(category => {
              return (
                <Category
                  key={category.id}
                  data={category}
                  animationTime={animationTime}
                />
              )
            })}
          </div>
        </div>
      </Layout>
    )
  }
}

export default Index

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        author {
          name
        }
      }
    }
  }
`
